import * as React from 'react'
import { NonThrowingComponent } from '../../../app-core/lib/ui/NonThrowingComponent'

export class TodoItemDetails extends NonThrowingComponent<{}, {}> {
    public tryRender() {
        return <div className="AppCore__ui__TodoItemDetails">{this.props.children}</div>
    }
}
